module.exports = __webpack_public_path__ + "media/luxury-2026/garden-architecture-7dc8f878.jpg";